import { defineMessages } from 'react-intl';

export const ReviewMessages = defineMessages({
  reviewTitle: {
    id: 'newEstimation.review.title',
    defaultMessage: 'Review Your Estimation',
  },
  reviewSubtitle: {
    id: 'newEstimation.review.subtitle',
    defaultMessage: '{providedPercentage}% of mandatory information has been provided',
  },
  reviewEmptyValue: {
    id: 'newEstimation.review.emptyValue',
    defaultMessage: '[Empty]',
  },
  noMandatoryMetadataDefinedSubtitle: {
    id: 'newEstimation.review.noMandatoryMetadataDefinedSubtitle',
    defaultMessage: 'No mandatory metadata has been defined',
  },
  aiReviewEnqueueLabel: {
    id: 'newEstimation.review.aiReviewEnqueueLabel',
    defaultMessage: 'Initiate AI Review',
  },
  aiReviewSuccessfullyEnqueued: {
    id: 'newEstimation.review.aiReviewSuccessfullyEnqueued',
    defaultMessage:
      'AI review has been successfully initiated, you will get a notification once it is completed.',
  },
});
